import Input, { type InputProps } from './Input';

export type TimeInputProps = Omit<InputProps, 'type' | 'ltr'>;

export default function TimeInput(props: TimeInputProps) {
  return <Input type="time" ltr leadingIcon="ri-time-line" dir="ltr" {...props} />;
}